import { inject, observer } from 'mobx-react';

import Icons from 'bz-core-controls/icons';
import ClinicalEndpoints from 'bz-pronto-core/endpoints/clinical';
import ProntoReportStatus from 'bz-pronto-core/enum/pronto-report-status';
import { action, computed } from 'mobx';
import React from 'react';
import Action from '../../../action-base';

@inject('vm', 'clinicalStore')
@observer
class CloneAction extends React.Component {
  render() {
    if (!this.show) return null;

    return <Action label="Clone & Edit" icon={Icons.edit} onClick={this.onClick.bind(this)} />;
  }

  @computed
  get show() {
    let { status } = this.props.vm.report;
    return status === ProntoReportStatus.Queried;
  }

  @action.bound
  onClick() {
    let { vm, clinicalStore } = this.props;
    let { caseStore, prontoStore, historyStore } = clinicalStore;

    let req = Object.assign({}, vm.report, { caseId: caseStore.id });

    ClinicalEndpoints.onCreate(req).then((res) => {
      let { reports, treatment } = res;

      vm.report.status = ProntoReportStatus.Resubmitted;

      prontoStore.onMerge(reports);
      historyStore.create(treatment);
    });
  }
}

CloneAction.defaultProps = {
  onEdit: () => {}
};

export default CloneAction;
